import { useEffect } from "react";
import { Box } from "@mui/material";

import ScreenContainer from "./ScreenContainer";

import connectWithDispatch from "../../../../../../Hooks/connectWithDispatch";

import * as appActions from "../../../../../../Actions/appActions";

import imageCalling from "../../../../../../Assets/StoryOfficer/CALL_JARED.png";

interface ScreenProps {
  transition: number;
  screen: number;
  setStory: (value: Partial<StoryType>) => void;
  t: (key: string) => ReactNode;
  theme: Theme;
}

const Screen8 = (props: ScreenProps) => {
  const { t, transition, screen, setStory } = props;
  const { main } = props.theme.palette.error;

  useEffect(() => {
    if (screen === 7) setTimeout(() => setStory({ screen: screen + 2 }), 4500);

    return () => {};
  }, [transition, screen, setStory]);

  return (
    <ScreenContainer>
      <Box sx={styles.topBox}>
        <Box sx={styles.title}>{t("commons.title")}</Box>
        <Box sx={styles.boxText}>
          <Box sx={styles.text_2}>
            {t("officer.stage_two.screen_7.text_1_part_1")}
            <span style={{ ...styles.span, color: main }}>{t("officer.stage_two.screen_7.text_1_part_2")}</span>.
          </Box>
          <Box sx={styles.text_2}>{t("officer.stage_two.screen_7.text_2")}</Box>
        </Box>
      </Box>
      <Box sx={styles.people}>
        <img src={imageCalling} alt="" style={styles.imageCalling} />
      </Box>
    </ScreenContainer>
  );
};

const styles = {
  topBox: {
    textAlign: "center",
    width: "100%",
    marginTop: "2.60416667em",
  },
  title: {
    fontSize: "1.4583em",
    fontWeight: "bold",
  },
  boxText: {
    marginTop: "0.41666667em",
  },
  text_2: {
    fontSize: "1.25em",
  },
  span: {
    fontSize: "1em",
  },
  people: {
    objectFit: "contain" as "contain",
    height: "100%",
    justifyContent: "center",
    alignItems: "center",
    display: "flex",
    marginTop: "2.60416667em",
  },
  imageCalling: {
    width: "19.352vh",
  },
};

const mapStateToProps = (state: StateType) => {
  return {
    screen: state.appReducer.story.screen,
    transition: state.appReducer.story.transition,
  };
};

const mapDispatchToProps: MapDispatchToProps = {
  setStory: appActions.setStory,
};

export default connectWithDispatch(Screen8, mapStateToProps, mapDispatchToProps);
